/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Dry-run resume preview (spec §resume): what a live resume WOULD do,
 * projected from ``RelinkCounts``' detection counters. Zero mutations happen
 * to produce these.
 */
export interface RelinkPreviewCounts {
  to_pull?: number;
  to_push?: number;
  conflicts_remote_wins?: number;
  remote_deleted?: number;
  backfilled?: number;
}
